import Gateway from '@nsftx/seven-gravity-gateway/slave';
import Retail from '@nsftx/seven-gravity-gateway/plugin-retail';
import merge from 'lodash/merge';
import ConfigService from './config';
import OfferService from './offer';
import gameConfig from '@/config/gameConfig';
import types from '@/store/mutationTypes';

let gateway = {};

const availableThemes = [16];

/**
 * Map games per product ID
 */
const gameMapper = {
  RushFootball2: 'rush_football_II',
  SportradarVirtualFootball: 'vfl_2',
};

/**
 * Send message to master
 *
 * @param {String} action
 * @param {Object} data
 */
function sendMessage(action, data) {
  gateway.sendMessage({
    action,
    data,
  });
}

/**
 * Subscribe to events
 */
function setListeners(store, router) {
  // Subscribe to game events
  gateway.subscribe('Master.Event', (message) => {
    const data = {
      key: message.key,
      router,
    };
    store.dispatch('masterEventMessage', data);
  });
  window.addEventListener('keydown', (message) => {
    if (message.code === 'Space') {
      const id = document.getElementById(message.srcElement.id) || null;
      if (id) {
        const { value } = id;
        id.blur();
        id.value = value;
      }
    }
    const data = {
      key: message.key,
      router,
    };
    store.dispatch('masterEventMessage', data);
  });
  gateway.subscribe('Widget.Event', (message) => {
    if (message.data.event === 'click') {
      const data = {
        key: message.data.shortcut,
        router,
      };
      store.dispatch('masterEventMessage', data);
    }

    if (message.data.action.acceptPayin) {
      store.dispatch('removeLockBets');
      store.dispatch('callPayin', message.data.action.stake);
      store.dispatch('clearBets');
    }
  });

  // Subscribe to ticket events
  gateway.subscribe('Tickets.ReBet', (message) => {
    store.dispatch('reBet', message.data.ticket);
  });
  // Subscribe to Betslip.Blocked events
  gateway.subscribe('Betslip.Blocked', (message) => {
    console.log('recevied Betslip.Blocked', message);
    store.dispatch('setBetslipBlocked', {
      blockers: message.data.blockers,
      type: 'add',
    });
  });
  // Subscribe to Betslip.Unblocked events
  gateway.subscribe('Betslip.Unblocked', (message) => {
    console.log('recevied Betslip.Unblocked', message);
    store.dispatch('setBetslipBlocked', {
      blockers: message.data.blockers,
      type: 'remove',
    });
  });
  gateway.subscribe('Tickets.PrePrint', (message) => {
    const additionalData = {
      additionalData: {
        ticketType: message.data.ticket.ticketType === 1 ? 'combo' : 'single',
        ticket: message.data.ticket,
        company: {
          currency: window.sevenConfig.company.currency,
        },
      },
    };
    const enforceEvent = {
      enforceEvent: true,
    };
    const data = merge(message.data, additionalData, enforceEvent);

    sendMessage('Tickets.Print', data);
  });
  gateway.subscribe('Tickets.Checked', (message) => {
    sendMessage('Widget.UpdateSettings', {
      gamesHelp: {
        show: false,
      },
      calculator: {
        show: false,
      },
      ticketSession: {
        show: false,
      },
      ticketList: {
        show: false,
      },
    });
    store.dispatch('setTicketPreview', message.data);
  });
  gateway.subscribe('Slave.Shown', () => {
    store.dispatch('setActiveGame', Date.now());
    store.commit(types.EDIT_BET, {});
    if (!Object.keys(store.getters.offer).length) {
      sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show: false,
        },
        calculator: {
          show: false,
        },
        ticketSession: {
          show: false,
        },
        ticketList: {
          show: false,
        },
      });
      router.push({ path: 'nofeed' });
      sendMessage('Dialog.ShowModal', {
        action: '7S:Dialog.ShowModal',
        message: store.getters.translations.noOffer || 'noOffer',
        type: 'warning',
        delay: 0,
      });
    } else {
      const show = !store.getters.ticketPreviewShow;
      sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show,
        },
        calculator: {
          show,
        },
        ticketSession: {
          show,
        },
        ticketList: {
          show,
        },
      });
      if (router.history.current.name !== 'betting') {
        router.push({ path: 'betting' });
      }
      sendMessage('Dialog.CloseModal', {
        action: '7S:Dialog.CloseModal',
        delay: 0,
      });
    }
  });
  gateway.subscribe('Tickets.PayingSentSuccess', () => {
    store.dispatch('clearBets');
    store.dispatch('clearRebet');
  });
}

/**
 * Search for query params of game/product Id
 *
 * @param {String} name - Name of query (game)
 * @returns {string}
 */
function getParam(name) {
  const url = window.location.href;
  const index = url.indexOf('?');
  let value;
  if (index >= 0) {
    const params = url.split('?')[1].split('&');
    const paramsObj = {};
    let i = 0;
    while (i < params.length) {
      const splited = params[i].split('=');
      const [first, second] = splited;
      paramsObj[first] = second;
      i += 1;
    }
    if (Object.prototype.hasOwnProperty.call(paramsObj, name)) {
      value = paramsObj[name];
    }
  }
  return value;
}
/**
 * Set sass theme
 */
function setTheme(data, store) {
  const companyId = 16;
  const index = availableThemes.indexOf(companyId);
  const themeNum = index < 0 ? 'default' : companyId;
  store.commit(types.SET_COMPANY_CONFIG, themeNum);
}

/**
 * Initialize gateway communication
 */
function init(store, router) {
  const { gameId } = store.getters;
  gateway = Gateway({
    debug: true,
    slaveId: gameId,
    data: {},
    plugins: [new Retail()],
    eventListeners: {
      keydown: ['67', '77', '79', '81', '187'],
    },
    eventPropagation: {
      keydown: '*',
    },
    load: (message) => {
      window.sevenConfig = message.data;
      ConfigService.getApiLocation(window.sevenConfig.company.uuid, gameId)
        .then(
          (apiLocationResponse) => {
            window.sevenConfig.integrationsApiLocation = apiLocationResponse.data;
            store.commit(types.SET_API_LOCATION_CONFIG, apiLocationResponse.data);
            // Get configuration service
            ConfigService.getGameConfig(window.sevenConfig.company.language, gameMapper[gameId])
              .then(
                (resp) => {
                  store.commit(types.SET_GAME_CONFIG, resp.data);
                  // Get offer service
                  OfferService.fetchOffer(window.sevenConfig.company.language, gameMapper[gameId])
                    .then(
                      (response) => {
                        if (Object.keys(response.data).length) {
                          store.commit(types.SET_OFFER, response.data);
                        }
                        // 'Slave' is ready for display
                        //  Set tax and rules info
                        gateway.sendMessage({
                          action: 'Slave.Loaded',
                          data: {
                            tax: {
                              payout: {
                                hideTax: resp.data.config.rules_payoutTax === null,
                                policy: resp.data.config.rules_payoutTax,
                                value: resp.data.config.rules_payoutTax !== null,
                              },
                              payin: {
                                hideTax: resp.data.config.rules_payinTax === null,
                                policy: resp.data.config.rules_payinTax,
                                value: resp.data.config.rules_payinTax !== null,
                              },
                            },
                            peripherals: {
                              printService: {
                                oddsType: resp.data.config.rules_oddsType,
                              },
                            },
                            ticketConfig: {
                              // color: gameConfig[gameId].color,
                              availableTicketActions: gameConfig[gameId].ticketActions,
                              validateTicket: false,
                              useTicketLocalStorage: true,
                              doTicketStatusCheck: true,
                              pendingTicketCheckInterval: 10000,
                              pendingTicketRejectPeriod: 30000,
                            },
                            // icon: gameConfig[gameId].icon,
                            // shortcuts: gameConfig[gameId].shortcuts,
                          },
                        });
                        store.commit(types.GATEWAY_LOADED, true);
                      },
                      () => {
                        const errorData = {
                          action: 'Dialog.ShowModal',
                          data: {
                            action: '7S:Dialog.ShowModal',
                            message: "Didn't fetch offer",
                            type: 'warning',
                            delay: 0,
                          },
                        };
                        gateway.sendMessage(errorData);
                        store.commit(types.GATEWAY_LOADED, true);
                      },
                    );
                },
                () => {
                  const errorData = {
                    action: 'Dialog.ShowModal',
                    data: {
                      action: '7S:Dialog.ShowModal',
                      message: "Didn't fetch game config",
                      type: 'warning',
                      delay: 0,
                    },
                  };
                  gateway.sendMessage(errorData);
                },
              );
          },
        );
      setTheme(window.sevenConfig, store);
    },
  });
  setListeners(store, router);
}
/**
 * Fetch proper game from query gameId
 */
function fetchGameId(store, router) {
  const gameId = getParam('productDisplayId');
  if (gameId) {
    store.commit(types.SET_GAME_ID, gameId);
    init(store, router);
  }
}

function getGateway() {
  return gateway;
}

export default {
  init,
  sendMessage,
  getGateway,
  fetchGameId,
};
